<button-detail-list-section [tabs]="tabs" [heading]="sectionHeader"></button-detail-list-section>
